import { RequestContext } from "@multiweb/types/multiweb";
import { ASServices } from "OW.Remoting/Basic/ServiceEndpoints";
import { CommunicationManager } from "./CommunicationManager";

export class LegacyUpTo2101CommunicationManager extends CommunicationManager {
    private _postOverrides: { [key: string]: (_functionName: string, _service: ASServices, urlParameters?: { [paramName: string]: any }, functionBody?: any, _priority?: number, _requestContext?: RequestContext) => Promise<any> } = {
        "GetRoleDefaultRights": this._getRoleDefaultRights,
        "Run": this._runMethod,
    };

    public override callPOSTRequest(functionName: string, service: ASServices, urlParameters?: { [paramName: string]: any }, functionBody?: any, priority?: number, requestContext?: RequestContext): Promise<any> {
        const func = this._postOverrides[functionName];
        if (func) {
            return func(functionName, service, urlParameters, functionBody, priority, requestContext);
        }
        return super.callPOSTRequest(functionName, service, urlParameters, functionBody, priority, requestContext);
    }

    private _getRoleDefaultRights(_functionName: string, _service: ASServices, urlParameters?: { [paramName: string]: any }, functionBody?: any, _priority?: number, _requestContext?: RequestContext): Promise<any> {
        return Promise.resolve({
            name: urlParameters.objectName,
            rights: functionBody.RoleIDs.map((rid: number) => {
                return {
                    id: rid,
                    visible: true,
                    enabled: true,
                    required: false,
                    postponedRequired: false,
                    recommended: false,
                    executable: true,
                    executableInEdit: false,
                    notInDB: true,
                };
            }),
        });
    }

    private _runMethod(functionName: string, service: ASServices, urlParameters?: { [paramName: string]: any }, functionBody?: any, priority?: number, requestContext?: RequestContext): Promise<any> {
        switch (urlParameters.className + ":" + urlParameters.methodName) {
            case "UserProfile:LoadFavoriteForms":
                return Promise.resolve(JSON.stringify({ forms: [] }));
            case "UserProfile:SaveFavoriteForms":
                return Promise.resolve(false);
            default:
                return super.callPOSTRequest(functionName, service, urlParameters, functionBody, priority, requestContext);
        }
    }
}
